<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5714 2.57143H3.42857C2.95519 2.57143 2.57143 2.95519 2.57143 3.42857V20.5714C2.57143 21.0447 2.95519 21.4286 3.42857 21.4286H20.5714C21.0447 21.4286 21.4286 21.0447 21.4286 20.5714V3.42857C21.4286 2.95519 21.0447 2.57143 20.5714 2.57143ZM3.42857 0H20.5714C22.465 0 24 1.53502 24 3.42857V20.5714C24 22.465 22.465 24 20.5714 24H3.42857C1.53502 24 0 22.465 0 20.5714V3.42857C0 1.53502 1.53502 0 3.42857 0Z"
      fill="currentColor"
    />
    <circle
      cx="6.5"
      cy="17.5"
      r="2"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5 19.5C14.5 13.9772 10.0228 9.5 4.5 9.5V12.5C8.36599 12.5 11.5 15.634 11.5 19.5H14.5Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5 19.5C19.5 19.5 19.5 19.5 19.5 19.5C19.5 11.2157 12.7843 4.5 4.5 4.5V7.5C11.1274 7.5 16.5 12.8726 16.5 19.5C16.5 19.5 16.5 19.5 16.5 19.5H19.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'FeedViewIcon' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
